import { FC } from "react";
import { useTranslation } from "react-i18next";
import { CheckCircle2 } from "lucide-react";

const PaymentAgreementSettledState: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center text-center px-6 py-14">
      <div className="relative mb-6">
        <div className="absolute inset-0 rounded-full bg-green-500/10 blur-xl" />
        <div className="relative flex h-20 w-20 items-center justify-center rounded-full bg-gradient-to-br from-green-500/10 to-green-500/5 ring-1 ring-inset ring-green-500/20">
          <CheckCircle2 className="h-9 w-9 text-green-600" strokeWidth={1.5} />
        </div>
      </div>
      <h3 className="text-lg font-semibold text-foreground">
        {t("fe.pages.flow.steps.paymentMethod.settledTitle")}
      </h3>
      <p className="mt-2 max-w-sm text-sm leading-6 text-muted-foreground">
        {t("fe.pages.flow.steps.paymentMethod.settledDescription")}
      </p>
    </div>
  );
};

export default PaymentAgreementSettledState;
